// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.experience-section {
  margin-bottom: 150px;
}
@media (max-width: 1023px) {
  .experience-section {
    margin-bottom: 96px;
  }
}
.experience-section .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 120px;
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .experience-section .container {
    gap: 60px;
  }
}
.experience-section .experience-content {
  flex: 1 1;
}
.experience-section .experience-content h2 {
  font-size: 42px;
  font-weight: 700;
  color: #072146;
  line-height: 1.2;
  margin-bottom: 40px;
}
.experience-section .experience-image {
  flex: 1 1;
}
.experience-section .experience-image img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
  height: 600px;
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .experience-section .experience-image img {
    max-height: unset;
    height: 600px;
  }
}
.experience-section .experience-image-mobile {
  display: none;
  transition: transform 0.3s ease;
}
.experience-section .experience-image-mobile:hover {
  transform: translateY(-10px);
}
.experience-section .experience-image-mobile img {
  width: 100%;
  height: unset;
  aspect-ratio: 4/3;
  border-radius: 20px;
  object-fit: cover;
}
.experience-section .stats-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.experience-section .stats-container .row-1, .experience-section .stats-container .row-2 {
  display: flex;
  gap: 20px;
  width: 100%;
}
@media (max-width: 1023px) {
  .experience-section .stats-container .row-1, .experience-section .stats-container .row-2 {
    flex-direction: column;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .experience-section .stats-container .row-1, .experience-section .stats-container .row-2 {
    flex-wrap: nowrap !important;
  }
}
.experience-section .stat-card {
  background-color: #fff;
  border-radius: 10px;
  padding: 25px;
  border: 1px solid #B4BBC5;
  flex: 1 1;
  min-width: 220px;
  max-width: 100%;
  transition: all 0.5s ease;
  position: relative;
  height: 180px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.experience-section .stat-card .stat-text {
  font-size: 16px;
  line-height: 1.6;
  font-weight: 400;
  color: #4A5D69;
  width: 100%;
  text-align: center;
  padding: 0 15px;
  transition: all 0.5s ease;
  opacity: 0;
  visibility: hidden;
  position: absolute;
}
@media (min-width: 1023px) and (max-width: 1200px) {
  .experience-section .stat-card .stat-text {
    font-size: 14px;
    padding: 0 5px;
  }
}
.experience-section .stat-card .stat-title {
  font-size: 20px;
  font-weight: 600 !important;
  color: #0D1317;
  width: 100%;
  text-align: center;
  transition: all 0.5s ease;
  opacity: 1;
  visibility: visible;
  position: relative !important;
}
@media (min-width: 1023px) and (max-width: 1200px) {
  .experience-section .stat-card .stat-title {
    font-size: 16px;
  }
}
.experience-section .stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  border-color: #367FAC;
}
.experience-section .stat-card:hover .stat-text {
  opacity: 1;
  visibility: visible;
}
.experience-section .stat-card:hover .stat-title {
  opacity: 0;
  visibility: hidden;
}
@media (min-width: 1024px) and (max-width: 1199px) {
  .experience-section .stat-card {
    padding: 10px;
    height: auto;
    display: block;
  }
  .experience-section .stat-card .stat-title {
    display: block !important;
    position: static !important;
    margin-bottom: 10px;
    font-size: 16px;
    text-align: left;
    opacity: 1 !important;
    visibility: visible !important;
  }
  .experience-section .stat-card .stat-text {
    display: block !important;
    position: static !important;
    font-size: 14px;
    line-height: 1.4;
    padding: 0;
    text-align: left !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  .experience-section .stat-card:hover {
    transform: none;
  }
  .experience-section .stat-card:hover .stat-title {
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none;
  }
  .experience-section .stat-card:hover .stat-text {
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none;
  }
}
@media (min-width: 1200px) {
  .experience-section .stat-card .stat-text {
    opacity: 0;
    visibility: hidden;
    position: absolute;
  }
  .experience-section .stat-card .stat-title {
    opacity: 1;
    visibility: visible;
    position: absolute;
  }
  .experience-section .stat-card:hover {
    transform: translateY(-5px);
  }
  .experience-section .stat-card:hover .stat-text {
    opacity: 1;
    visibility: visible;
  }
  .experience-section .stat-card:hover .stat-title {
    opacity: 0;
    visibility: hidden;
  }
}
@media (max-width: 1023px) {
  .experience-section .container {
    flex-direction: column;
    gap: 40px;
  }
  .experience-section .experience-content {
    width: 100%;
  }
  .experience-section .experience-content h2 {
    text-align: center;
    font-size: 32px;
  }
  .experience-section .experience-image {
    display: none;
  }
  .experience-section .experience-image-mobile {
    display: block;
    width: 100%;
    margin: 40px 0;
  }
  .experience-section .experience-image-mobile img {
    width: 100%;
    height: unset;
    aspect-ratio: 4/3;
    border-radius: 20px;
    object-fit: cover;
  }
  .experience-section .stats-container {
    width: 100%;
    justify-content: center;
    margin-top: 0;
    flex-direction: column;
  }
  .experience-section .stats-container .row-1, .experience-section .stats-container .row-2 {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 20px;
    margin-bottom: 20px;
  }
  .experience-section .stat-card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 10px);
    min-width: 0;
    max-width: calc(50% - 10px);
    height: auto;
    padding: 25px;
    display: block;
  }
  .experience-section .stat-card .stat-title {
    display: block !important;
    position: static !important;
    margin-bottom: 20px;
    font-size: 18px;
    text-align: left;
    opacity: 1 !important;
    visibility: visible !important;
  }
  .experience-section .stat-card .stat-text {
    display: block !important;
    position: static !important;
    font-size: 14px;
    line-height: 1.4;
    padding: 0;
    text-align: left !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  .experience-section .stat-card:hover {
    transform: none;
  }
  .experience-section .stat-card:hover .stat-title {
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none;
  }
  .experience-section .stat-card:hover .stat-text {
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none;
  }
}
@media (max-width: 767px) {
  .experience-section .experience-content h2 {
    font-size: 39px !important;
    text-align: left;
  }
  .experience-section .stats-container {
    margin-top: 40px;
    gap: 20px;
  }
  .experience-section .stats-container .row-1, .experience-section .stats-container .row-2 {
    flex-direction: column;
    flex-wrap: nowrap;
    margin: 0px !important;
    gap: 0px;
  }
  .experience-section .stat-card {
    flex: 0 0 100%;
    min-width: 0;
    max-width: 100%;
    text-align: center;
    gap: 20px;
    margin-bottom: 20px;
  }
  .experience-section .stat-card:last-child {
    margin-bottom: 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/experience/Experience.scss"],"names":[],"mappings":"AACA;EACI,oBAAA;AAAJ;AAEI;EAHJ;IAIQ,mBAAA;EACN;AACF;AACI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;AACR;AACQ;EANJ;IAOQ,SAAA;EAEV;AACF;AACI;EACI,SAAA;AACR;AACQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AACZ;AAGI;EACI,SAAA;AADR;AAIQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;AAFZ;AAIY;EAPJ;IAQQ,iBAAA;IACA,aAAA;EADd;AACF;AAKI;EACI,aAAA;EACA,+BAAA;AAHR;AAKQ;EACI,4BAAA;AAHZ;AAMQ;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAJZ;AAQI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AANR;AAQQ;EACI,aAAA;EACA,SAAA;EACA,WAAA;AANZ;AAQY;EALJ;IAMQ,sBAAA;EALd;AACF;AAQQ;EACI;IACI,4BAAA;EANd;AACF;AAUI;EACI,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARR;AAUQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AARZ;AAUY;EAbJ;IAcQ,eAAA;IACA,cAAA;EAPd;AACF;AAUQ;EACI,eAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;AARZ;AAUY;EAXJ;IAYQ,eAAA;EAPd;AACF;AAUQ;EACI,2BAAA;EACA,0CAAA;EACA,qBAAA;AARZ;AAUY;EACI,UAAA;EACA,mBAAA;AARhB;AAWY;EACI,UAAA;EACA,kBAAA;AAThB;AAeI;EACI;IACI,aAAA;IACA,YAAA;IACA,cAAA;EAbV;EAeU;IACI,yBAAA;IACA,2BAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;IACA,qBAAA;IACA,8BAAA;EAbd;EAgBU;IACI,yBAAA;IACA,2BAAA;IACA,eAAA;IACA,gBAAA;IACA,UAAA;IACA,2BAAA;IACA,qBAAA;IACA,8BAAA;EAdd;EAiBU;IACI,eAAA;EAfd;EAiBc;IACI,yBAAA;IACA,qBAAA;IACA,8BAAA;IACA,eAAA;EAflB;EAkBc;IACI,yBAAA;IACA,qBAAA;IACA,8BAAA;IACA,eAAA;EAhBlB;AACF;AAsBI;EAEQ;IACI,UAAA;IACA,kBAAA;IACA,kBAAA;EArBd;EAwBU;IACI,UAAA;IACA,mBAAA;IACA,kBAAA;EAtBd;EAyBU;IACI,2BAAA;EAvBd;EAyBc;IACI,UAAA;IACA,mBAAA;EAvBlB;EA0Bc;IACI,UAAA;IACA,kBAAA;EAxBlB;AACF;AA6BI;EACI;IACI,sBAAA;IACA,SAAA;EA3BV;EA8BM;IACI,WAAA;EA5BV;EA8BU;IACI,kBAAA;IACA,eAAA;EA5Bd;EAgCM;IACI,aAAA;EA9BV;EAiCM;IACI,cAAA;IACA,WAAA;IACA,cAAA;EA/BV;EAkCU;IACI,WAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;IACA,iBAAA;EAhCd;EAoCM;IACI,WAAA;IACA,uBAAA;IACA,aAAA;IACA,sBAAA;EAlCV;EAoCU;IACI,aAAA;IACA,mBAAA;IACA,iBAAA;IACA,SAAA;IACA,mBAAA;EAlCd;EAsCM;IACI,YAAA;IAAA,cAAA;IAAA,4BAAA;IACA,YAAA;IACA,2BAAA;IACA,YAAA;IACA,aAAA;IACA,cAAA;EApCV;EAsCU;IACI,yBAAA;IACA,2BAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;IACA,qBAAA;IACA,8BAAA;EApCd;EAuCU;IACI,yBAAA;IACA,2BAAA;IACA,eAAA;IACA,gBAAA;IACA,UAAA;IACA,2BAAA;IACA,qBAAA;IACA,8BAAA;EArCd;EAwCU;IACI,eAAA;EAtCd;EAwCc;IACI,yBAAA;IACA,qBAAA;IACA,8BAAA;IACA,eAAA;EAtClB;EAyCc;IACI,yBAAA;IACA,qBAAA;IACA,8BAAA;IACA,eAAA;EAvClB;AACF;AA4CI;EAEQ;IACI,0BAAA;IACA,gBAAA;EA3Cd;EA+CM;IACI,gBAAA;IACA,SAAA;EA7CV;EA+CU;IACI,sBAAA;IACA,iBAAA;IACA,sBAAA;IACA,QAAA;EA7Cd;EAiDM;IACI,cAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,SAAA;IACA,mBAAA;EA/CV;EAiDU;IACI,6BAAA;EA/Cd;AACF","sourcesContent":["// Tecrübe ve Uzmanlık Bölümü\n.experience-section {\n    margin-bottom: 150px;\n\n    @media (max-width: 1023px) {\n        margin-bottom: 96px;\n    }\n    \n    .container {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 120px;\n\n        @media (min-width: 1024px) and (max-width: 1200px) {\n            gap: 60px;\n        }\n    }\n    \n    .experience-content {\n        flex: 1;\n        \n        h2 {\n            font-size: 42px;\n            font-weight: 700;\n            color: #072146;\n            line-height: 1.2;\n            margin-bottom: 40px;\n        }\n    }\n    \n    .experience-image {\n        flex: 1;\n       \n        \n        img {\n            width: 100%;\n            height: 100%;\n            border-radius: 10px;\n            object-fit: cover;\n            height: 600px;\n\n            @media (min-width: 1024px) and (max-width: 1200px) {\n                max-height: unset;\n                height: 600px;\n            }\n        }\n    }\n    \n    .experience-image-mobile {\n        display: none;\n        transition: transform 0.3s ease;\n        \n        &:hover {\n            transform: translateY(-10px);\n        }\n        \n        img {\n            width: 100%;\n            height: unset;\n            aspect-ratio: 4 / 3;\n            border-radius: 20px;\n            object-fit: cover;\n        }\n    }\n    \n    .stats-container {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n\n        .row-1, .row-2 {\n            display: flex;\n            gap: 20px;\n            width: 100%;\n            \n            @media (max-width: 1023px) {\n                flex-direction: column;\n            }\n        }\n\n        @media (min-width: 1024px) and (max-width: 1200px) {\n            .row-1, .row-2 {\n                flex-wrap: nowrap !important;\n            }\n        }\n    }\n    \n    .stat-card {\n        background-color: #fff;\n        border-radius: 10px;\n        padding: 25px;\n        border: 1px solid #B4BBC5;\n        flex: 1;\n        min-width: 220px;\n        max-width: 100%;\n        transition: all 0.5s ease;\n        position: relative;\n        height: 180px;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        \n        .stat-text {\n            font-size: 16px;\n            line-height: 1.6;\n            font-weight: 400;\n            color: #4A5D69;\n            width: 100%;\n            text-align: center;\n            padding: 0 15px;\n            transition: all 0.5s ease;\n            opacity: 0;\n            visibility: hidden;\n            position: absolute;\n\n            @media (min-width: 1023px)  and (max-width: 1200px){\n                font-size: 14px;\n                padding: 0 5px;\n            }\n        }\n        \n        .stat-title {\n            font-size: 20px;\n            font-weight: 600 !important;\n            color: #0D1317;\n            width: 100%;\n            text-align: center;\n            transition: all 0.5s ease;\n            opacity: 1;\n            visibility: visible;\n            position: relative !important;\n\n            @media (min-width: 1023px)  and (max-width: 1200px){\n                font-size: 16px;\n            }\n        }\n        \n        &:hover {\n            transform: translateY(-5px);\n            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n            border-color: #367FAC;\n            \n            .stat-text {\n                opacity: 1;\n                visibility: visible;\n            }\n            \n            .stat-title {\n                opacity: 0;\n                visibility: hidden;\n            }\n        }\n    }\n    \n    // 1024px-1199px arasını kapsayan ekranlar için\n    @media (min-width: 1024px) and (max-width: 1199px) {\n        .stat-card {\n            padding: 10px;\n            height: auto;\n            display: block;\n            \n            .stat-title {\n                display: block !important;\n                position: static !important;\n                margin-bottom: 10px;\n                font-size: 16px;\n                text-align: left;\n                opacity: 1 !important;\n                visibility: visible !important;\n            }\n            \n            .stat-text {\n                display: block !important;\n                position: static !important;\n                font-size: 14px;\n                line-height: 1.4;\n                padding: 0;\n                text-align: left !important;\n                opacity: 1 !important;\n                visibility: visible !important;\n            }\n            \n            &:hover {\n                transform: none;\n                \n                .stat-title {\n                    display: block !important;\n                    opacity: 1 !important;\n                    visibility: visible !important;\n                    transform: none;\n                }\n                \n                .stat-text {\n                    display: block !important;\n                    opacity: 1 !important;\n                    visibility: visible !important;\n                    transform: none;\n                }\n            }\n        }\n    }\n    \n    // 1200px üzerinde hover efektini korumak için\n    @media (min-width: 1200px) {\n        .stat-card {\n            .stat-text {\n                opacity: 0;\n                visibility: hidden;\n                position: absolute;\n            }\n            \n            .stat-title {\n                opacity: 1;\n                visibility: visible;\n                position: absolute;\n            }\n            \n            &:hover {\n                transform: translateY(-5px);\n                \n                .stat-text {\n                    opacity: 1;\n                    visibility: visible;\n                }\n                \n                .stat-title {\n                    opacity: 0;\n                    visibility: hidden;\n                }\n            }\n        }\n    }\n    \n    @media (max-width: 1023px) {\n        .container {\n            flex-direction: column;\n            gap: 40px;\n        }\n        \n        .experience-content {\n            width: 100%;\n            \n            h2 {\n                text-align: center;\n                font-size: 32px;\n            }\n        }\n        \n        .experience-image {\n            display: none;\n        }\n        \n        .experience-image-mobile {\n            display: block;\n            width: 100%;\n            margin: 40px 0;\n            \n            \n            img {\n                width: 100%;\n                height: unset;\n                aspect-ratio: 4 / 3;\n                border-radius: 20px;\n                object-fit: cover;\n            }\n        }\n        \n        .stats-container {\n            width: 100%;\n            justify-content: center;\n            margin-top: 0;\n            flex-direction: column;\n            \n            .row-1, .row-2 {\n                display: flex;\n                flex-direction: row;\n                flex-wrap: nowrap;\n                gap: 20px;\n                margin-bottom: 20px;\n            }\n        }\n        \n        .stat-card {\n            flex: 0 0 calc(50% - 10px);\n            min-width: 0;\n            max-width: calc(50% - 10px);\n            height: auto;\n            padding: 25px;\n            display: block;\n            \n            .stat-title {\n                display: block !important;\n                position: static !important;\n                margin-bottom: 20px;\n                font-size: 18px;\n                text-align: left;\n                opacity: 1 !important;\n                visibility: visible !important;\n            }\n            \n            .stat-text {\n                display: block !important;\n                position: static !important;\n                font-size: 14px;\n                line-height: 1.4;\n                padding: 0;\n                text-align: left !important;\n                opacity: 1 !important;\n                visibility: visible !important;\n            }\n            \n            &:hover {\n                transform: none;\n                \n                .stat-title {\n                    display: block !important;\n                    opacity: 1 !important;\n                    visibility: visible !important;\n                    transform: none;\n                }\n                \n                .stat-text {\n                    display: block !important;\n                    opacity: 1 !important;\n                    visibility: visible !important;\n                    transform: none;\n                }\n            }\n        }\n    }\n    \n    @media (max-width: 767px) {\n        .experience-content {\n            h2 {\n                font-size: 39px !important;\n                text-align: left;\n            }\n        }\n        \n        .stats-container {\n            margin-top: 40px;\n            gap: 20px;\n            \n            .row-1, .row-2 {\n                flex-direction: column;\n                flex-wrap: nowrap;\n                margin: 0px !important;\n                gap: 0px;\n            }\n        }\n        \n        .stat-card {\n            flex: 0 0 100%;\n            min-width: 0;\n            max-width: 100%;\n            text-align: center;\n            gap: 20px;\n            margin-bottom: 20px;\n\n            &:last-child {\n                margin-bottom: 0px !important;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
